module.exports = __webpack_public_path__ + "static/media/YMLATJSONBSOTK3.243dd26d.png";